import React from 'react';
import ReactDOM from 'react-dom';
import Home from './pages/Home';
import Error from './pages/Error';
import Success from './pages/success';
import { Switch, Route, HashRouter as Router } from 'react-router-dom';
import PrivateRoute from './components/router/privateRoute';
import PrivateStateFullRoute from './components/router/privateStateFulRoute';
import * as serviceWorker from './serviceWorker';
import './index.scss';
import { initSentry, logger, Sentry, ErrorBoundary } from 'common-utilities';

// Initialize Sentry
initSentry();

// Global error handlers
window.addEventListener('unhandledrejection', event => {
	logger.error('Unhandled promise rejection:', event.reason);
	Sentry.captureException(event.reason);
});

window.onerror = (message, source, lineno, colno, error) => {
	logger.error('Global error:', { message, source, lineno, colno, error });
	Sentry.captureException(error || new Error(message));
};

ReactDOM.render(
	<React.StrictMode>
		<ErrorBoundary>
			<Router hashType={'slash'}>
				<Switch>
					<PrivateRoute path="/success" exact>
						<PrivateStateFullRoute>
							<Success />
						</PrivateStateFullRoute>
					</PrivateRoute>
					<Route path="/error" exact>
						<Error />
					</Route>
					<PrivateRoute path="/">
						<Home />
					</PrivateRoute>
				</Switch>
			</Router>
		</ErrorBoundary>
	</React.StrictMode>,
	document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
